import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { store } from "./redux/store";
import { Provider as ReduxProvider } from "react-redux";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  createHttpLink,
  gql,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import axios from "axios";

const httpLink = createHttpLink({
  uri: "https://data-explorer.pulsarplatform.com/graphql/trac",
  credentials: "include",
  fetchOptions: {
    mode: "no-cors",
  },
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists

  console.log("HTTP =======", headers);
  const token =
    "Bearer eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyMTQ2MSwidXNlcl92ZXJzaW9uIjoiMjAyMS0wOS0wOCAwNDo1OTowMyAtMDcwMCIsInNhbWVfb3JpZ2luIjpmYWxzZX0.JqPdHjAva6ATgRQ2Jg7zh_0j7NN0gT01dmeNY1XYFbg";
  return {
    headers: {
      authorization: token,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export const PROOF_OF_MARKETING = client
  .query({
    query: gql`
      query ComplexResults($filter: Filter!) {
        results(filter: $filter) {
          total
          results {
            createdAt
            content
            engagement
            sentiment
            visibility
          }
        }
      }
    `,
  })
  .then((res) => console.log(res))
  .catch((error) => console.log("Message: ", error.message));
// THROUGH AXIOS

// const filter = {
//   filter: {
//     dateFrom: "2021-09-20T00:00:00Z",
//     dateTo: "2021-09-24T23:59:59Z",
//     searches: ["de257fcbbc5caceab08c537fa16524e4"],
//   },
// };

// async function getResult() {
//   let result = await axios({
//     url: "https://data-explorer.pulsarplatform.com/graphql/trac",
//     method: "post",
//     data: {
//       query: `query ComplexResults($filter: Filter!) {
//         results(filter: ${filter}) {
//         total
//         results {
//         createdAt
//         content
//         engagement
//         sentiment
//         visibility
//       }
//     }
//     }`,
//     },
//     headers: {
//       // "Access-Control-Allow-Origin": "*",
//       "Content-type": "application/json",
//       "Access-Control-Allow-Origin": "*",
//       "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
//       mode: "no-cors",
//       Authorization:
//         "Bearer eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyMTQ2MSwidXNlcl92ZXJzaW9uIjoiMjAyMS0wOS0wOCAwNDo1OTowMyAtMDcwMCIsInNhbWVfb3JpZ2luIjpmYWxzZX0.JqPdHjAva6ATgRQ2Jg7zh_0j7NN0gT01dmeNY1XYFbg",
//     },
//   });
//   console.log(result.data.data, "result ");
// }

// getResult();

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ReduxProvider store={store}>
        <App />
      </ReduxProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
